/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {
  setBusy,
  clearBusy,
} from '../../../irmlib/src/containers'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { Box, Typography, Grid } from '@mui/material'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import MaterialTable from '../../Controls/MaterialReactTable'

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)``

const ViewBoxTransmittalsData = (props) => {
  const value = props.FilterData
  const transmittalType = props.transmittalType
  const { t } = useTranslation()
  const [transmittalData, setData] = React.useState([])
  const [templateDataList, setTemplateDataList] = useState(false)

  useEffect(async() => {
    setTemplateDataList(false)
    getPageData()
  }, [value])
  useEffect(async() => {
    getPageData()
    const unsubscribe = await gdeTransactions.getBoxTransmittalsListener('listener', value, setTemplateDataList)
    return () => unsubscribe()
  }, [value])

  useEffect(async() => {
    getPageData()
  }, [templateDataList, transmittalType])

  const dataRet = async (val) => {
    setBusy()
    let collection
    if (templateDataList) {
      collection = templateDataList
    } else {
      collection = await gdeTransactions.getBoxTransmittalsListener(
        'normal',
        val,
        false
      )
    }
    const activityList = []
    const promises = []
    collection?.docs?.forEach(async (doc) => {
      const docData = doc.data()
      const { id, accountLevel1, building, formatError, status, createdTs, flatFileDetails, imgDetails, imgReference, template, wmsStatus, wmsRegion, idp, batchId } = docData
      let dateOfCreation = false
      const flatFileIdData = flatFileDetails !== undefined ? flatFileDetails?.dataFile : '-'
      if (createdTs) {
        dateOfCreation = moment(createdTs.seconds, 'X').format('YYYY-MM-DD')
      }

      if (dateOfCreation === 'Invalid date') {
        dateOfCreation = createdTs.substring(0, 10)
      }
      const templateFields = Object.keys(template).map((key) => {
        // eslint-disable-next-line
        const data = key + '(' + template[key].fieldId + ')' + ',' + ' '
        return data
      })
      activityList.push({
        id: id,
        batchId: batchId,
        customerId: accountLevel1,
        building: building,
        formatError: formatError,
        status: status,
        dateCreated: dateOfCreation,
        imgDetails: imgDetails,
        imgReference: imgReference,
        wmsStatus: wmsStatus,
        wmsRegion: wmsRegion,
        fields: templateFields,
        exception: idp?.exception,
        flatFileId: flatFileIdData
      })
    })
    let filteredData
    if (transmittalType === 'box') {
      filteredData = activityList.filter((transmittal) => {
        return !transmittal.batchId && transmittal
      })
    } else if (transmittalType === 'batch') {
      filteredData = activityList.filter((transmittal) => {
        return transmittal.batchId && transmittal
      })
    }
    await Promise.all(promises)
    setData(filteredData)
    clearBusy()
    return activityList
  }

  const getPageData = async (page, pageSize) => {
    try {
      const data = await dataRet(value)
      return data
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching page data:', error)
      return []
    }
  }

  return (
    <>
      <TableContainer>
        <Box boxShadow={3} borderRadius={4}>
          <Grid item container sx={{ padding: '10px 15px 0px' }}>
            <Grid item container alignItems={'center'}>
              <Typography variant='h6' gutterBottom style={{ marginTop: '15px', color: '#58595B' }}>
                {t('routeTitles.viewBoxTransmittals')}
              </Typography>
            </Grid>
          </Grid>
          <MaterialTable
            data={transmittalData}
            tableFor='smart_catalog_view_transmittals'
          />
        </Box>
      </TableContainer>
    </>
  )
}
ViewBoxTransmittalsData.propTypes = {
  FilterData: PropTypes.object,
  // DataSearch: PropTypes.string,
}

export default ViewBoxTransmittalsData
